'use client'
import { createIconic } from '../../Iconic.js';

const BanxaIcon = createIconic({
    alt: 'Banxa',
    iconName: 'banxa',
    sourcePath: 'icons/onramps/banxa.svg',
});
const CoinbasePayIcon = createIconic({
    alt: 'Coinbase Pay',
    iconName: 'coinbase-pay',
    sourcePath: 'icons/onramps/coinbase-pay.svg',
});

export { BanxaIcon, CoinbasePayIcon };
